module.exports = __webpack_public_path__ + "img/高人效智能客服管理.e16372a3.png";